<script>
import {replace} from 'svelte-spa-router'
import { site } from '../stores/Site';

if ($site == 'ff3') {
    replace('/fund')
} else {
    replace('/upcoming')
}
</script>